export default __webpack_public_path__ + "static/media/DainikBhaskar.17bc82d4.jpg";